import { Injectable } from '@angular/core';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { RequiredUserActionsDaoService } from '../required-user-actions-dao.service';
import { RequiredUserActionHolder } from 'src/app/_services/user-action-validator/required-user-action-validator.service';

// CONSTANTS
const REQUIRED_USER_ACTIONS_KEY = 'requireduseractions';

@Injectable()
export class RequiredUserActionsStorageDaoService
  implements RequiredUserActionsDaoService
{
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public saveRequiredUserActionsData(
    requiredUserActionsData: RequiredUserActionHolder[],
  ): Promise<void> {
    return this.keyValueStorage.store(
      REQUIRED_USER_ACTIONS_KEY,
      requiredUserActionsData,
    );
  }
  public getRequiredUserActionsData(): Promise<RequiredUserActionHolder[]> {
    return this.keyValueStorage.load(REQUIRED_USER_ACTIONS_KEY);
  }

  public async reset() {}

  public async clear() {
    await this.keyValueStorage.delete(REQUIRED_USER_ACTIONS_KEY);
  }
}
